export default __webpack_public_path__ + "static/media/money-exchange-ic.d91c8fdc.svg";